import script from "./PayrollEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./PayrollEdit.vue?vue&type=script&setup=true&lang=js"

import "./PayrollEdit.vue?vue&type=style&index=0&id=23590398&lang=css"

const __exports__ = script;

export default __exports__